import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daysSinceBirth',
  pure: true // default, but explicit is good
})
export class DaysSinceBirthPipe implements PipeTransform {

  transform(dob: string | Date | null): number | null {
    if (!dob) return null;

    const birthDate = new Date(dob);
    const today = new Date();

    const diff = today.getTime() - birthDate.getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24));
  }
}